import type { IExchangeMetadata } from '../types.js'

export const exchanges: IExchangeMetadata[] = [
  {
    "id": "1inch",
    "filePath": "exchange:1inch",
    "name": "1inch",
    "type": "dex",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "balancer",
    "filePath": "exchange:balancer",
    "name": "Balancer",
    "type": "dex",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bancor",
    "filePath": "exchange:bancor",
    "name": "Bancor",
    "type": "dex",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "binance",
    "filePath": "exchange:binance",
    "name": "Binance",
    "type": "cex",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bithumb",
    "filePath": "exchange:bithumb",
    "name": "Bithumb",
    "type": "cex",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bitstamp",
    "filePath": "exchange:bitstamp",
    "name": "Bitstamp",
    "type": "cex",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "btcturk",
    "filePath": "exchange:btcturk",
    "name": "BTC Turk",
    "type": "cex",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "bybit",
    "filePath": "exchange:bybit",
    "name": "Bybit",
    "type": "cex",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "coinbase",
    "filePath": "exchange:coinbase",
    "name": "Coinbase",
    "type": "dex",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "cowswap",
    "filePath": "exchange:cowswap",
    "name": "Cow Swap",
    "type": "dex",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "crypto-com",
    "filePath": "exchange:crypto-com",
    "name": "Crypto.com",
    "type": "cex",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gate-io",
    "filePath": "exchange:gate-io",
    "name": "Gate Io",
    "type": "cex",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "gemini",
    "filePath": "exchange:gemini",
    "name": "Gemini",
    "type": "cex",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kraken",
    "filePath": "exchange:kraken",
    "name": "Kraken",
    "type": "cex",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "kucoin",
    "filePath": "exchange:kucoin",
    "name": "Kucoin",
    "type": "cex",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "odos",
    "filePath": "exchange:odos",
    "name": "Odos",
    "type": "dex",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "okx",
    "filePath": "exchange:okx",
    "name": "OkX",
    "type": "cex",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "pancake-swap",
    "filePath": "exchange:pancake-swap",
    "name": "Pancake Swap",
    "type": "dex",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "para-swap",
    "filePath": "exchange:para-swap",
    "name": "ParaSwap",
    "type": "dex",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "paribu",
    "filePath": "exchange:paribu",
    "name": "Paribu",
    "type": "cex",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "sushiswap",
    "filePath": "exchange:sushiswap",
    "name": "Sushi Swap",
    "type": "dex",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "swissborg",
    "filePath": "exchange:swissborg",
    "name": "SwissBorg",
    "type": "cex",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "uniswap",
    "filePath": "exchange:uniswap",
    "name": "Uniswap",
    "type": "dex",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "upbit",
    "filePath": "exchange:upbit",
    "name": "UpBit",
    "type": "cex",
    "variants": [
      "branded",
      "mono",
      "background"
    ]
  },
  {
    "id": "aevo",
    "filePath": "exchange:aevo",
    "name": "Aevo",
    "type": "dex",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "paradex",
    "filePath": "exchange:paradex",
    "name": "Paradex",
    "type": "dex",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "bitget",
    "filePath": "exchange:bitget",
    "name": "Bitget",
    "type": "cex",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  },
  {
    "id": "hyperliquid",
    "filePath": "network:hyper-evm",
    "name": "Hyperliquid",
    "type": "dex",
    "variants": [
      "background",
      "branded",
      "mono"
    ]
  }
]